import React from "react"
import classNames from "classnames"
import { Toast as ReactToast } from "react-bootstrap"

import Button from "../../../components/Button"

export interface ToastProps {
  id: number
  type: "primary" | "danger" | "warning" | "success"
  title: string
  messages: string[]
  autoClose?: boolean
  onClose: () => void
}

const Toast = (props: ToastProps) => {
  const additionalMessages =
    props.messages.length > 0 ? (
      <ReactToast.Body className="mt-3">
        {props.messages.map((message, i) => (
          <div key={i}>
            <small>{message}</small>
          </div>
        ))}
      </ReactToast.Body>
    ) : null

  return (
    <ReactToast
      id={"toast_" + props.id}
      className={classNames(
        "toast-" + props.type,
        "position-relative h-auto d-block"
      )}
      show={true}
      delay={8000}
      autohide={props.autoClose}
      onClose={props.autoClose ? props.onClose : undefined}
    >
      <ReactToast.Header
        className="d-flex justify-content-between align-items-center"
        closeButton={false}
      >
        {props.title}
        {!props.autoClose && (
          <Button
            variant="dark"
            textOnly={true}
            data-dismiss="toast"
            aria-label="Close"
            onClick={props.onClose}
            className="ml-2"
          >
            Close
          </Button>
        )}
      </ReactToast.Header>
      {additionalMessages}
    </ReactToast>
  )
}

export default Toast
